import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { createABEQuotation, updateABEQuotation } from 'src/_helpers/api';

const name = 'abeQuotations';

const initialState = {
  quotations: [],
  error: null,
};

const addABEQuotationAsync = createAsyncThunk(`${name}/add-quotation`, async (quotationData) => {
    // prendre la date d'aujourd'hui avec le bon format au lieu du formattage de JS pour le .json
    const monthNames = ["Jan", "Fev", "Mar", "Avr", "Mai", "Juin",
        "Juillet", "Aout", "Sep", "Oct", "Nov", "Dec"
    ];
    const today = new Date();
    const day = `${today.getDate() < 10 ? "0" : ""}${today.getDate()}`;
    const year = today.getFullYear();
    const hours = today.getHours();
    const minutes = today.getMinutes();

    const formattedDate = `${day}/${monthNames[today.getMonth()]}/${year} ${hours}:${minutes}`;

    const apiData = {
        AccuCore: quotationData.accuCore,
        AccessControl: quotationData.accessControl,
        AirFlowType: quotationData.airFlowType,
        Arrangement: quotationData.arrangement,
        City:
            quotationData.shipping !== 'Not Included' || quotationData.startUp !== 'Not Included'
                ? quotationData.city
                : null,
        Communication: quotationData.communication,
        ContactName: quotationData.contactName,
        Controls: quotationData.controls,
        Country:
            quotationData.shipping !== 'Not Included' || quotationData.startUp !== 'Not Included'
                ? quotationData.country
                : null,
        Customer: quotationData.customer,
        DoorConstruction: quotationData.doorConstruction,
        Elevation: quotationData.elevation,
        ExtraSetFilters: quotationData.extraSetFilters,
        FiltersLevel: quotationData.filtersLevel,
        FiltersType: quotationData.filtersType,
        Finish: quotationData.finish,
        Location: quotationData.location,
        Margin: quotationData.margin,
        Material: quotationData.material,
        MERVFreshReturnAirFilters: 'Null',
        MotorOversizeFactor: quotationData.motorOversizeFactor,
        NumberUnits: quotationData.numberUnits,
        OAEADamper: quotationData.oaeaDamper,
        ProductName: quotationData.productName,
        Product_id: quotationData.product_id,
        ProjectName: quotationData.projectName,
        ProjectNumber: quotationData.projectNumber,
        Province:
            quotationData.shipping !== 'Not Included' || quotationData.startUp !== 'Not Included'
                ? quotationData.province
                : null,
        QuotationStatus: quotationData.quotationStatus,
        QuoteDate: formattedDate,
        Representative: quotationData.representative,
        ReturnAirESP: quotationData.returnAirESP,
        ReturnAirHighVolume: quotationData.returnAirHighVolume,
        ReturnAirMinVolume: quotationData.returnAirMinVolume,
        RoofCurb: 'Not Included',
        Shipping: quotationData.shipping,
        StartUp: quotationData.startUp,
        SubmittedBy: quotationData.submittedBy,
        SummerConditionsOutdoorRH: quotationData.summerConditionsOutdoorRH,
        SummerConditionsOutdoorTdB: quotationData.summerConditionsOutdoorTdB,
        SummerConditionsOutdoorTwB: quotationData.summerConditionsOutdoorTwB,
        SummerConditionsReturnRH: quotationData.summerConditionsReturnRH,
        SummerConditionsReturnTdB: quotationData.summerConditionsReturnTdB,
        SummerConditionsReturnTwB: quotationData.summerConditionsReturnTwB,
        SupplyAirESP: quotationData.supplyAirESP,
        SupplyAirHighVolume: quotationData.supplyAirHighVolume,
        SupplyAirMinVolume: quotationData.supplyAirMinVolume,
        Template_id: quotationData.template_id,
        UnitsTag: quotationData.unitsTag,
        UserId: quotationData.UserId,
        Voltage: quotationData.voltage,
        WinterConditionsOutdoorRH: quotationData.winterConditionsOutdoorRH,
        WinterConditionsOutdoorTdB: quotationData.winterConditionsOutdoorTdB,
        WinterConditionsOutdoorTwB: quotationData.winterConditionsOutdoorTwB,
        WinterConditionsReturnRH: quotationData.winterConditionsReturnRH,
        WinterConditionsReturnTdB: quotationData.winterConditionsReturnTdB,
        WinterConditionsReturnTwB: quotationData.winterConditionsReturnTwB,
    }


    //console.log('🚀 ~ addQuotationAsync ~ quotationData:', apiData)
    let response

    /////////////// IF ITS A REVISON CREATION ///////////////
    if (quotationData.id) {
        const apiData = {
            ABEQuotationCode: quotationData.quote,
            AccuCore: quotationData.accuCore,
            AccessControl: quotationData.accessControl,
            AirFlowType: quotationData.airFlowType,
            Arrangement: quotationData.arrangement,
            CancelPrecedentVersion: quotationData.cancelPrecedentVersion,
            City:
                quotationData.shipping !== 'Not Included' || quotationData.startUp !== 'Not Included'
                    ? quotationData.city
                    : null,
            Communication: quotationData.communication,
            ContactName: quotationData.contactName || null,
            Controls: quotationData.controls,
            Country:
                quotationData.shipping !== 'Not Included' || quotationData.startUp !== 'Not Included'
                    ? quotationData.country
                    : null,
            Customer: quotationData.customer || "",
            DoorConstruction: quotationData.doorConstruction,
            Elevation: quotationData.elevation,
            ExtraSetFilters: quotationData.extraSetFilters,
            FiltersLevel: quotationData.filtersLevel,
            FiltersType: quotationData.filtersType,
            Finish: quotationData.finish,
            Location: quotationData.location,
            Margin: quotationData.margin,
            Material: quotationData.material,
            MERVFreshReturnAirFilters: 'Null',
            MotorOversizeFactor: quotationData.motorOversizeFactor,
            NumberUnits: quotationData.numberUnits,
            OAEADamper: quotationData.oaeaDamper,
            Product_id: quotationData.product_id, 
            ProjectName: quotationData.projectName,
            ProjectNumber: quotationData.projectNumber,
            ProductName: quotationData.productName, 
            Province:
                quotationData.shipping !== 'Not Included' || quotationData.startUp !== 'Not Included'
                    ? quotationData.province
                    : null,
            QuotationStatus: quotationData.quotationStatus,
            Quote: quotationData.quote,
            QuoteDate: formattedDate,
            Representative: quotationData.representative || null,
            ReturnAirESP: quotationData.returnAirESP,
            ReturnAirHighVolume: quotationData.returnAirHighVolume,
            ReturnAirMinVolume: quotationData.returnAirMinVolume,
            RoofCurb: 'Not Included',
            Shipping: quotationData.shipping,
            StartUp: quotationData.startUp,
            SubmittedBy: quotationData.submittedBy,
            SummerConditionsOutdoorRH: quotationData.summerConditionsOutdoorRH,
            SummerConditionsOutdoorTdB: quotationData.summerConditionsOutdoorTdB,
            SummerConditionsOutdoorTwB: quotationData.summerConditionsOutdoorTwB,
            SummerConditionsReturnRH: quotationData.summerConditionsReturnRH,
            SummerConditionsReturnTdB: quotationData.summerConditionsReturnTdB,
            SummerConditionsReturnTwB: quotationData.summerConditionsReturnTwB,
            SupplyAirESP: quotationData.supplyAirESP,
            SupplyAirHighVolume: quotationData.supplyAirHighVolume,
            SupplyAirMinVolume: quotationData.supplyAirMinVolume,
            Template_id: quotationData.template_id,
            UnitsTag: quotationData.unitsTag,
            UserId: quotationData.UserId,
            Voltage: quotationData.voltage,
            WinterConditionsOutdoorRH: quotationData.winterConditionsOutdoorRH,
            WinterConditionsOutdoorTdB: quotationData.winterConditionsOutdoorTdB,
            WinterConditionsOutdoorTwB: quotationData.winterConditionsOutdoorTwB,
            WinterConditionsReturnRH: quotationData.winterConditionsReturnRH,
            WinterConditionsReturnTdB: quotationData.winterConditionsReturnTdB,
            WinterConditionsReturnTwB: quotationData.winterConditionsReturnTwB,
        };
        
        //console.log("apiData: ", apiData)
        response = await updateABEQuotation(apiData)

    } else {

        /////////////// IF ITS AN ORIGINAL SUBMISSION CREATION ///////////////
        const apiData = {
            AccuCore: quotationData.accuCore,
            AccessControl: quotationData.accessControl,
            AirFlowType: quotationData.airFlowType,
            Arrangement: quotationData.arrangement,
            City:
                quotationData.shipping !== 'Not Included' || quotationData.startUp !== 'Not Included'
                    ? quotationData.city
                    : null,
            Communication: quotationData.communication,
            ContactName: quotationData.contactName || null,
            Controls: quotationData.controls,
            Country:
                quotationData.shipping !== 'Not Included' || quotationData.startUp !== 'Not Included'
                    ? quotationData.country
                    : null,
            Customer: quotationData.customer || "",
            DoorConstruction: quotationData.doorConstruction,
            Elevation: quotationData.elevation,
            ExtraSetFilters: quotationData.extraSetFilters,
            FiltersLevel: quotationData.filtersLevel,
            FiltersType: quotationData.filtersType,
            Finish: quotationData.finish,
            Location: quotationData.location,
            Margin: quotationData.margin,
            Material: quotationData.material,
            MERVFreshReturnAirFilters: 'Null',
            MotorOversizeFactor: quotationData.motorOversizeFactor,
            NumberUnits: quotationData.numberUnits,
            OAEADamper: quotationData.oaeaDamper,
            ProductName: quotationData.productName,
            Product_id: quotationData.product_id,
            ProjectName: quotationData.projectName,
            ProjectNumber: quotationData.projectNumber,
            Province:
                quotationData.shipping !== 'Not Included' || quotationData.startUp !== 'Not Included'
                    ? quotationData.province
                    : null,
            QuotationStatus: quotationData.quotationStatus,
            QuoteDate: formattedDate,
            Representative: quotationData.representative || null,
            ReturnAirESP: quotationData.returnAirESP,
            ReturnAirHighVolume: quotationData.returnAirHighVolume,
            ReturnAirMinVolume: quotationData.returnAirMinVolume,
            RoofCurb: 'Not Included',
            Shipping: quotationData.shipping,
            StartUp: quotationData.startUp,
            SummerConditionsOutdoorRH: quotationData.summerConditionsOutdoorRH,
            SummerConditionsOutdoorTdB: quotationData.summerConditionsOutdoorTdB,
            SummerConditionsOutdoorTwB: quotationData.summerConditionsOutdoorTwB,
            SummerConditionsReturnRH: quotationData.summerConditionsReturnRH,
            SummerConditionsReturnTdB: quotationData.summerConditionsReturnTdB,
            SummerConditionsReturnTwB: quotationData.summerConditionsReturnTwB,
            SubmittedBy: quotationData.submittedBy,
            SupplyAirESP: quotationData.supplyAirESP,
            SupplyAirHighVolume: quotationData.supplyAirHighVolume,
            SupplyAirMinVolume: quotationData.supplyAirMinVolume,
            Template_id: quotationData.template_id,
            UnitsTag: quotationData.unitsTag,
            UserId: quotationData.UserId,
            Voltage: quotationData.voltage,
            WinterConditionsOutdoorRH: quotationData.winterConditionsOutdoorRH,
            WinterConditionsOutdoorTdB: quotationData.winterConditionsOutdoorTdB,
            WinterConditionsOutdoorTwB: quotationData.winterConditionsOutdoorTwB,
            WinterConditionsReturnRH: quotationData.winterConditionsReturnRH,
            WinterConditionsReturnTdB: quotationData.winterConditionsReturnTdB,
            WinterConditionsReturnTwB: quotationData.winterConditionsReturnTwB,
    };
        //console.log('QDDD : ' + quotationData)
        response = await createABEQuotation(apiData)
    }
    return response
})

const abeQuotationSlice = createSlice({
  name,
  initialState,
  reducers: {
    resetState: (state) => {
      state.quotations = [];
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(addABEQuotationAsync.pending, (state) => {
        state.error = null;
      })
      .addCase(addABEQuotationAsync.fulfilled, (state, action) => {
        state.quotations = action.payload;
      })
      .addCase(addABEQuotationAsync.rejected, (state, action) => {
        state.error = action.error;
      });
  },
});

export const abeQuotationActions = {
  ...abeQuotationSlice.actions,
  addABEQuotationAsync,
};

export const abeQuotationsReducer = abeQuotationSlice.reducer;
